import React from 'react'
import PropTypes from 'prop-types'
import WidgetPage from 'components/hocs/widget-page'
import { ThemeContext } from '@cred/react-theme'
import MortgageRateWidget from './widget'

const MortgageRateTableContainer = (props) => {
  const { theme } = props
  const getTheme = () => {
    switch (theme) {
      case 'fox':
        return 'fox1'
      case 'insider':
        return 'insider'
      case 'credible':
        return 'credible3'
      default:
        return 'credible3'
    }
  }

  // The container was added for the React ReactResizeDetector correct working
  return (
    <div>
      <ThemeContext.Provider value={getTheme()}>
        <MortgageRateWidget {...props} theme={getTheme()} />
      </ThemeContext.Provider>
    </div>
  )
}

MortgageRateTableContainer.propTypes = {
  theme: PropTypes.string,
}
MortgageRateTableContainer.defaultProps = {
  theme: 'credible3',
}


export default WidgetPage(MortgageRateTableContainer)
